module.exports = __webpack_public_path__ + "img/rocketchat.cb9730e0.svg";